import * as React from "react";
import { cloneDeep } from "lodash";
import TextField from "@material-ui/core/TextField";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../model/state-models";
import { Filters } from "../model/search-base-model";
import { setFilter } from "../slice/search-slice";
import { makeStyles } from "@material-ui/core";

export const searchFilterKey = "searchContent";


interface SearchBarProps {
  label?: string;
  searchProperties?: string[];
  searchPlaceHolder?: string;
}

const useStyles = makeStyles((theme) =>({
  formControl: {
    minWidth: 200,
    margin: theme.spacing(1),
  },
}));
export function SearchBar(props: SearchBarProps) {
  const [searchText, setSearchText] = React.useState("");
  const dispatch = useDispatch();
  const classes = useStyles();

  const filters = useSelector<AppState<any>, Filters>(
    (state) => state?.searchState?.filters
  );
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event?.target;
    if (value?.length > 0) {
      const category = {
        id: value,
        value: value?.toLocaleLowerCase(),
        displayText: value,
        searchAble: true,
      };
      props?.searchProperties.forEach((a) => {
        filters[a] = [category];
      });
    } else {
      props?.searchProperties.forEach((a) => {
        delete filters[a];
      });
    }
    const deepClone = cloneDeep(filters);
    dispatch(setFilter(deepClone));
    setSearchText(value);
  };

  return (
    <TextField
      id="outlined-name"
      className={classes.formControl}
      label={props?.label}
      value={searchText}
      placeholder={props?.searchPlaceHolder}
      onChange={handleChange}
    />
  );
}

SearchBar.defaultProps = {
  searchProperties: [],
  searchPlaceHolder: 'search',
  label: 'search',
};